module.exports = __webpack_public_path__ + "img/image13.86b4430d.jpg";